export default __webpack_public_path__ + "media/Pages/pickups/assets/techno_logo_black-1a838476766886e5dccb38c2f9d64ee5.png";